// normalize CSS across browsers
import "./src/css/normalize.css"

// custom CSS styles
import "./src/css/style.css"
import "./src/css/theme.css"

// custom gatsby plugin breadcrumb css style
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css"

// Currency Changer utility
import {
  changeCurrency,
  getCurrencyFromQuery,
  getPreferredCurrency,
  initCurrencyChanger,
  markCurrencyReady,
} from './src/utils/currencyChanger'
import { whenSectionsHydrated } from './src/components/contentBlocks/lazySection'
import { applyStyleFamilies, unlinkedStyleFamilies } from './src/utils/styleFamilies'

export { wrapPageElement } from './src/i18n/LocaleProvider';

// In production these section families are separate stylesheets, linked only
// on the pages that render them (scripts/style-families). The dev server does
// not post-process HTML, so they stay global there. Webpack drops this branch
// from production bundles.
if (process.env.NODE_ENV === 'development') {
  require('./src/css/@wordpress/block-library/build-style/style.css');
  require('./src/css/@wordpress/block-library/build-style/theme.css');
  require('./src/components/cloudHosting/cloudHosting.css');
  require('./src/components/cloudHosting/hostingSite.css');
  require('./src/components/cloudHosting/productLines.css');
  require('./src/components/productMarketing/productMarketing.css');
  require('./src/components/productMarketing/variants/variants.css');
  require('./src/components/productMarketing/adoption/adoption.css');
}

// Get theme from environment variable - webpack DefinePlugin replaces process.env.THEME at build time
// The value comes from .env file read by gatsby-node.js and passed via DefinePlugin
// Note: In browser context, we can't read .env directly, so we rely on DefinePlugin injection
const theme = process.env.THEME || 'default';

// Debug: Log the theme being loaded (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('[Theme Loader] Theme from env:', process.env.THEME, '| Using theme:', theme);
}

// CRITICAL: Import theme CSS based on environment variable
// Webpack DefinePlugin replaces process.env.THEME with the actual string value at build time
// This allows webpack to statically analyze and only include the selected theme CSS (tree-shaking)
// These requires MUST be at the top level (not inside if statements) so webpack can analyze them
if (theme === 'bbh') {
  require('./src/css/themes/bbh.css');
} else if (theme === 'sunset') {
  require('./src/css/themes/sunset.css');
} else if (theme === 'mint') {
  require('./src/css/themes/mint.css');
} else if (theme === 'ocean') {
  require('./src/css/themes/ocean.css');
} else if (theme === 'pastel') {
  require('./src/css/themes/pastel.css');
} else if (theme === 'earth') {
  require('./src/css/themes/earth.css');
} else if (theme === 'neon') {
  require('./src/css/themes/neon.css');
} else if (theme === 'lavender') {
  require('./src/css/themes/lavender.css');
} else if (theme === 'autumn') {
  require('./src/css/themes/autumn.css');
} else if (theme === 'forest') {
  require('./src/css/themes/forest.css');
} else if (theme === 'monochrome') {
  require('./src/css/themes/monochrome.css');
} else if (theme === 'black-friday') {
  require('./src/css/themes/black-friday.css');
} else if (theme === 'christmas') {
  require('./src/css/themes/christmas.css');
} else if (theme === 'halloween') {
  require('./src/css/themes/halloween.css');
} else if (theme === 'valentines') {
  require('./src/css/themes/valentines.css');
} else if (theme === 'cyber-monday') {
  require('./src/css/themes/cyber-monday.css');
} else if (theme === 'royal-purple') {
  require('./src/css/themes/royal-purple.css');
} else if (theme === 'pohela-boishakh') {
  require('./src/css/themes/pohela-boishakh.css');
} else if (theme === 'ramadan') {
  require('./src/css/themes/ramadan.css');
} else if (theme === 'eid-fitr') {
  require('./src/css/themes/eid-fitr.css');
} else if (theme === 'independence-day') {
  require('./src/css/themes/independence-day.css');
} else if (theme === 'victory-day') {
  require('./src/css/themes/victory-day.css');
} else if (theme === 'language-day') {
  require('./src/css/themes/language-day.css');
} else if (theme === 'durga-puja') {
  require('./src/css/themes/durga-puja.css');
} else if (theme === 'new-year') {
  require('./src/css/themes/new-year.css');
} else if (theme === 'spring') {
  require('./src/css/themes/spring.css');
} else if (theme === 'summer-solstice') {
  require('./src/css/themes/summer-solstice.css');
} else if (theme === 'monsoon') {
  require('./src/css/themes/monsoon.css');
} else if (theme === 'winter') {
  require('./src/css/themes/winter.css');
} else if (theme === 'earth-day') {
  require('./src/css/themes/earth-day.css');
} else if (theme === 'nordic-fjord') {
  require('./src/css/themes/nordic-fjord.css');
} else if (theme === 'nordic-aurora') {
  require('./src/css/themes/nordic-aurora.css');
} else if (theme === 'nordic-birch') {
  require('./src/css/themes/nordic-birch.css');
} else if (theme === 'nordic-midsummer') {
  require('./src/css/themes/nordic-midsummer.css');
} else if (theme === 'nordic-hygge') {
  require('./src/css/themes/nordic-hygge.css');
} else if (theme === 'nordic-minimal') {
  require('./src/css/themes/nordic-minimal.css');
} else if (theme === 'hosting-purple') {
  require('./src/css/themes/hosting-purple.css');
} else if (theme === 'site-green') {
  require('./src/css/themes/site-green.css');
} else if (theme === 'god-teal') {
  require('./src/css/themes/god-teal.css');
} else if (theme === 'blue-cloud') {
  require('./src/css/themes/blue-cloud.css');
} else if (theme === 'budget-orange') {
  require('./src/css/themes/budget-orange.css');
} else if (theme === 'dream-purple') {
  require('./src/css/themes/dream-purple.css');
} else if (theme === 'digitaloc-blue') {
  require('./src/css/themes/digitaloc-blue.css');
} else if (theme === 'premium-managed') {
  require('./src/css/themes/premium-managed.css');
} else if (theme === 'cosmic-indigo') {
  require('./src/css/themes/cosmic-indigo.css');
} else if (theme === 'signal-cyan') {
  require('./src/css/themes/signal-cyan.css');
} else if (theme === 'verdant-cloud') {
  require('./src/css/themes/verdant-cloud.css');
} else if (theme === 'solar-amber') {
  require('./src/css/themes/solar-amber.css');
} else if (theme === 'nimbus-slate') {
  require('./src/css/themes/nimbus-slate.css');
} else {
  // Default theme
  require('./src/css/themes/default.css');
}

// Store theme in window for layout.js to access
if (typeof window !== 'undefined') {
  window.__THEME__ = theme;
  console.log('[Theme Loader] Stored theme in window.__THEME__:', theme);
}

// Fallback placeholder for broken images
const FALLBACK_IMAGE_PATH = '/default-fallback-image.png';

// Initialize Currency Changer on client entry
export const onClientEntry = () => {
  // Initialize currency changer after page loads
  if (typeof window !== 'undefined') {
    // Wait for DOM to be ready before initializing
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initCurrencyChanger({ autoConvert: false, observeMutations: true });
      });
    } else {
      initCurrencyChanger({ autoConvert: false, observeMutations: true });
    }

    // Global handler: replace broken images with placeholder
    document.addEventListener('error', (e) => {
      const el = e.target;
      if (
        el.tagName === 'IMG' &&
        el.src &&
        !el.src.endsWith(FALLBACK_IMAGE_PATH) &&
        !el.dataset.fallbackApplied
      ) {
        el.dataset.fallbackApplied = 'true';
        el.src = FALLBACK_IMAGE_PATH;
      }
    }, true);
  }
};

// React has now hydrated the SSR markup. Apply the pre-paint currency once,
// then reveal the currency selector. Main content is visible from SSR.
// Lazily loaded sections hydrate after this hook fires; converting their
// server HTML before that makes React discard and re-render them, shifting
// the layout. Wait until every section on the page has hydrated.
// Client-side navigation can reach a page whose section family this document
// did not link. The families are only prefetched (cached, not applied) in idle
// time, so the first page carries no unused stylesheet; they are applied the
// moment a client-side navigation starts, from cache, in the same position
// relative to the global sheet as the build gives them.
const prefetchStyleFamilies = () => {
  for (const { href } of unlinkedStyleFamilies()) {
    if (document.querySelector(`link[rel="prefetch"][href="${href}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'style';
    link.href = href;
    document.head.appendChild(link);
  }
};

export const onPreRouteUpdate = ({ prevLocation }) => {
  if (typeof window === 'undefined' || !prevLocation) return;
  applyStyleFamilies();
};

export const onInitialClientRender = () => {
  if (typeof window === 'undefined') return;
  const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 2000));
  idle(prefetchStyleFamilies);
  whenSectionsHydrated().then(() => {
    try {
      changeCurrency(getPreferredCurrency());
    } catch (error) {
      // Resolving the currency must never keep the selector hidden.
      console.error('[currency] initial conversion failed:', error);
      markCurrencyReady();
    }
  });
};

// Apply currency query parameters on every Gatsby page, including client-side
// navigation between pages (for example, /wordpress-hosting/?currency=bdt).
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return;

  const queryCurrency = getCurrencyFromQuery(location?.search);
  if (!queryCurrency) return;

  // Let Gatsby finish rendering the new page before converting its prices.
  window.requestAnimationFrame(() => {
    changeCurrency(queryCurrency);
  });
};
